<!-- =========================================================================================
    File Name: DailySales.vue
    Description: Daily Sales statistic
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-2">
        <div class="vx-row">
          <div class="ml-2 mr-2" style="min-width: 495px;">
            <ejs-daterangepicker ref="period" :startDate="startDate" :endDate="endDate" floatLabelType="Auto" placeholder="Seleccione período"/>
          </div>
          <div>
            <vs-button radius color="success" size="large" type="filled" icon-pack="feather" icon="icon-search" class="ml-4 mt-2" @click="getReport"/>
          </div>
          <div>
            <vs-button radius size="large" type="filled" icon-pack="feather" icon="icon-save" class="ml-4 mt-2" @click="excelExport" v-show="gridReady"/>
          </div>
        </div>
      </vx-card>
      <vx-card ref="reportCard" v-show="gridReady">
        <ejs-pivotview
          ref="pivot"
          :dataSourceSettings="dataSourceSettings"
          locale='es-GT'
          showFieldList=true
          height="600"
          :allowExcelExport='true'
          showTooltip=true
        />
      </vx-card>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';

  var deltaPOS_config = require('@/deltaPOS.config.js')

  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import {PivotViewPlugin, GroupingBar, ExcelExport, FieldList} from '@syncfusion/ej2-vue-pivotview';

  Vue.use(DateRangePickerPlugin);
  Vue.use(PivotViewPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'daterangepicker': {
        placeholder: 'Seleccione período',
        startLabel: 'Fecha inicial',
        endLabel: 'Fecha final',
        applyText: 'Seleccionar',
        cancelText: 'Cancelar',
        selectedDays: 'Seleccione día inicial y final',
        days: 'Días'
      },
      'pivotview': {
        grandTotal: 'Gran total',
        total: 'Total',
        value: 'Valor',
        noValue: 'Sin valor',
        row: 'Fila',
        column: 'Columna',
        collapse: 'Colapsar',
        expand: 'Expandir',
        rowAxisPrompt: 'Arrastre fila aquí',
        columnAxisPrompt: 'Arrastre columna aquí',
        valueAxisPrompt: 'Arrastre valor aquí',
        filterAxisPrompt: 'Arrastre filtro aquí',
        filter: 'Filtro',
        filtered: 'Filtrado',
        sort: 'Ordenar',
        filters: 'Filtros',
        rows: 'Filas',
        columns: 'Columnas',
        values: 'Valores',
        close: 'Cerrar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        calculatedField: 'Campo calculado',
        sum: 'Suma'
      },
      "pivotfieldlist": {
        'fieldList': 'Lista de campos',
        'dropRowPrompt': 'Arrastre fila aquí',
        'dropColPrompt': 'Arrastre columna aquí',
        'dropValPrompt': 'Arrastre valor aquí',
        'dropFilterPrompt': 'Arrastre fo;trp aquí',
        'addPrompt': 'Agregar campo',
        'centerHeader': 'Centrar encabezado:',
        'add': 'Agregar',
        'drag': 'Arrastrar',
        'filters': 'Filtros',
        'rows': 'Filas',
        'columns': 'Columnas',
        'values': 'Valores',
        'error': 'Error',
        'dropAction': 'El campo calculado no puede estar en otra región excepto el valor en eje.',
        'search': 'Buscar',
        'close': 'Cerrar',
        'cancel': 'Cancelar',
        'delete': 'Eliminar',
        'alert': 'Alerta',
        'warning': 'Advertencia',
        'ok': 'Aceptar',
        'allFields': 'Todos los campos',
        'noMatches': 'Sin coincidencias'
      },
      'grid': {
        'EmptyRecord': 'No se encontraron datos',
        'Search': 'Buscar',
        'Excelexport': 'Exportar',
        'GroupDropArea': 'Arrastre un encabezado de columna aquí para agrupar por esa columna'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        dataSourceSettings: {
          dataSource: this.data,
          expandAll: false,
          values: [{name: 'Venta total'}, {name: '# Transacciones'}, {name: 'Venta promedio'}, {name: 'Unidades vendidas'}, {name: 'Unidades por transacción'}],
          rows: [{name: 'Mes'}, {name: 'Fecha'}],
          formatSettings: [
            {name: 'Venta total', format: 'N2'},
            {name: '# Transacciones', format: 'N0'},
            {name: 'Venta promedio', format: 'N2'},
            {name: 'Unidades vendidas', format: 'N0'},
            {name: 'Unidades por transacción', format: 'N0'},
          ],
          filters: []
        },
        mounted: false,
        gridReady: false,
        allowFiltering: true,
        startDate: null,
        endDate: null,
        toolbarOptions: ['ExcelExport'],
        data: []
      }
    },
    provide: {
      pivotview: [ExcelExport, GroupingBar, FieldList]
    },
    methods: {
      formatDate: function (field, data) {
        var d = new Date(data[field].replace('Z', ''));
        // return d.toLocaleString();
        // return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
        return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
      },
      dateISOFormat(value) {
        const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
        return d.toISOString();
      },
      toolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          this.$refs.grid.excelExport({fileName: `VentasDiarias.xlsx`});
        }
      },
      excelExport() {
        var pivot = this.$refs.pivot.ej2Instances;
        pivot.excelExport({fileName: `VentasDiarias.xlsx`});
      },
      getReport() {
        this.startDate = this.$refs.period.getSelectedRange().startDate;
        this.endDate = this.$refs.period.getSelectedRange().endDate;
        if (this.startDate) {
          if (this.endDate) {
            this.startDate.setHours(0);
            this.startDate.setMinutes(0);
            this.startDate.setSeconds(0);
            this.endDate.setHours(23);
            this.endDate.setMinutes(59);
            this.endDate.setSeconds(59);
            if (this.startDate < this.endDate) {
              this.$vs.loading({
                text: 'Cargando consulta',
                type: 'point'
              });
              var self = this;
              var data = {
                startDate: this.dateISOFormat(this.startDate),
                endDate: this.dateISOFormat(this.endDate),
                userId: this.$store.state.AppActiveUser.userId,
                token: this.$store.state.AppActiveUser.token
              };
              this.$http.post(deltaPOS_config.default.apiURL + '/statistics/sales/daily_sales', data).then(response => {
                if (response.data.success) {
                  if (response.data.data) {
                    self.data = response.data.data;
                    self.$refs.pivot.ej2Instances.dataSourceSettings.dataSource = self.data;
                    self.gridReady = true;
                  } else {
                    self.$vs.notify({
                      title: 'Error al cargar kardex',
                      text: response.data.message,
                      color: 'danger'
                    });
                  }
                  self.$vs.loading.close();
                } else {
                  self.$vs.notify({
                    title: 'Error al cargar informe',
                    text: response.data.message,
                    color: 'danger'
                  });
                  self.$vs.loading.close();
                }
              }).catch(error => {
                var errorMessage = '';
                if (error.response) {
                  errorMessage = error.response.data.ErrorMessage;
                } else {
                  errorMessage = 'Error de conectividad'
                }
                self.$vs.notify({
                  title: 'Error al cargar informe',
                  text: errorMessage,
                  color: 'danger'
                });
                self.$vs.loading.close();
              });
            }
          }
        }
      },
      refreshData() {
        this.getReport();
      },
    },
    mounted() {
      this.startDate = new Date();
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);
      this.startDate.setSeconds(0);
      this.startDate.setDate(1)
      this.endDate = new Date();
      this.endDate.setHours(23);
      this.endDate.setMinutes(59);
      this.endDate.setSeconds(59);
    }
  }

</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";*/
  @import "../../../../node_modules/@syncfusion/ej2-grids/styles/material.css";
  /*@import "../../../../node_modules/@syncfusion/ej2-pivotview/styles/material.css";*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css";*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
  @import "../../../../node_modules/@syncfusion/ej2-vue-pivotview/styles/material.css";
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-buttons/styles/material.css";*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-splitbuttons/styles/material.css";*/
</style>
